import styled from "styled-components"

export const EndAutomaticallyDiv = styled.div`
        display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

`

export const OptionDescription = styled.div`
    display: flex;
    width: 60%;
    font-size: 14px;
    color: #888888;
`

export const OptionsContainer = styled.div`
    display: flex;
    width: 100%; 
    flex-direction: column; 
    max-height: 800px;
    height: fit-content;
    gap: 20px;
`

export const OptionsWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

export const OptionsWrap2 = styled.div`
    display: flex;
    flex-direction: column; 
    width: 100%;

`

export const CreateQASessionWrap = styled.div`
    width: 1200px;
    max-width: 92vw;
    background-color: white;
    border-radius: 10px;
    height: fit-content;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    padding: 0px 20px;

    @media (max-width: 768px) {
        width: 95%;
        max-width: 95%;
    }
`
